@if (showNavbar$()) {
  <sol-banner-host />
  <div class="sol-app-container">
    <div class="sol-app-navbar">
      <sol-navbar />
    </div>
    <div class="sol-app-content" data-shortcut-layer="content">
      <sol-details>
        <sol-topbar>
          <ng-container slot="actions">
            <sol-button-group
              size="small"
              [value]="theme$()"
              [availableValues]="themes$()"
              (value)="onThemeChange($event)"
            />
          </ng-container>
        </sol-topbar>
        <sol-page>
          <sol-page-banner-host />
          @if (activeRouteStatus$() === 'loading') {
            <sol-loader [loader]="SolLoader.ofBlocks(3).withMargin('0')" />
          } @else if (activeRouteStatus$() === 'forbidden') {
            <sol-error-page [type]="SolErrorPageType.FORBIDDEN" />
          } @else {
            <router-outlet />
          }
        </sol-page>
      </sol-details>
    </div>
  </div>
} @else {
  @if (activeRouteStatus$() === 'loading') {
    <sol-loader [loader]="SolLoader.ofBlocks(3)" />
  } @else if (activeRouteStatus$() === 'forbidden') {
    <sol-error-page [type]="SolErrorPageType.FORBIDDEN" />
  } @else {
    <router-outlet />
  }
}
<sol-overlays />
